import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getWizardInstanceDelegation } from 'api/Wizard/Wizard';

export const useGetWizardDelegatedTasks = ({ params = {}, options = {} }) => {
  const navigate = useNavigate();

  const queryKey = [
    'wizard-instance-delegation',
    params.wizard_instance_id,
    params.page,
    params.limit,
    JSON.stringify(params.filters || {})
  ];

  return useQuery(queryKey, () => getWizardInstanceDelegation(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 30000,
    cacheTime: 5 * 60 * 1000,
    ...options
  });
};
